import { select, call, put, takeLatest } from 'redux-saga/effects'
import Alert from 'react-s-alert';
import { defineTypes } from '../helpers'
import UserEndpoint from '../persistence/UserEndpoint'
import { reduxFetch } from '../http/reduxFetch'

const inviteUserTypes = { ...defineTypes('INVITE/USER') }

export const initialState = {
  loading: false,
  loaded: false,
  email: '',
  error: {}
}

export const actions = {
  inviteUser () {
    return { type: inviteUserTypes.REQUEST }
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case inviteUserTypes.REQUEST:
      return { ...state, loading: true }
    case inviteUserTypes.FAILURE:
      return { ...state, loading: false, error: action.error }
    case inviteUserTypes.SUCCESS:
      return { ...state, email: '', loading: false }
    default:
      return state
  }
}

export const selectors = {
  email: ({ invite  }) => invite.email,
  invite_user_email_values: ({ form }) => {
    return form
      && form.invite_user_form
      && form.invite_user_form.values
  },
}

export function * inviteUserSaga ({ serial_number }) {
  try {
    let form = {}
    let form_values = yield select(selectors.invite_user_email_values)
    form['email'] = form_values['new_user_email']

    const email = yield call(reduxFetch, UserEndpoint.invite(form))
    yield put({ type: inviteUserTypes.SUCCESS, email: email.data })
    yield call(Alert.success, '<div>Invite sent!</div>')
  } catch (error) {
    yield put({ type: inviteUserTypes.FAILURE, error })
    yield put({ type: inviteUserTypes.FAILURE, error: error })
  }
}

export function * rootSaga () {
  yield takeLatest(inviteUserTypes.REQUEST, inviteUserSaga)
}




// WEBPACK FOOTER //
// ./src/sagas/inviteUser.js